import { useState, useCallback } from "react";
import { Snackbar, Alert, AlertTitle } from "@mui/material";

const useAlert = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
    title: "",
  });

  const showAlert = useCallback((options) => {
    setSnackbar({
      open: true,
      title: "",
      severity: "success",
      message: "",
      ...options,
    });
  }, []);

  const handleClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const AlertSnackbar = (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbar.severity}
        variant="outlined"
        sx={{ width: "100%", bgcolor: "background.paper" }}
      >
        {snackbar.title && <AlertTitle>{snackbar.title}</AlertTitle>}
        {snackbar.message}
      </Alert>
    </Snackbar>
  );

  return { showAlert, AlertSnackbar };
};

export default useAlert;

